(function () {

  // ─── Constants ───────────────────────────────────────────────────────────────

  var PURCHASE_HISTORY_STORAGE_KEY = 'purchaseHistory';
  var PURCHASE_HISTORY_EXPIRY_MS = 1000 * 60 * 10; // 10 minutes — keep in sync with productHelper usePurchaseHistory

  var HAWKSEARCH_HIERARCHY_STORAGE_KEY = 'hawksearchHierarchy';
  var HAWKSEARCH_HIERARCHY_EXPIRY_MS = 1000 * 60 * 10; // 10 minutes

  var HAWKSEARCH_SORT2_MAX_RETRIES = 50;
  var HAWKSEARCH_PAGESIZE2_MAX_RETRIES = 50;
  var EXCLUDE_OOS_MAX_RETRIES = 50;
  var FOCUS_FIRST_RESULT_MAX_RETRIES = 50;
  var HAWKSEARCH_MOBILE_ADJUST_MAX = 30;

  // ─── Did-You-Mean Skip Interceptor ──────────────────────────────────────────
  // When the user explicitly clicks "Search for '<original>'" we set a sessionStorage
  // flag before navigating. On the next page load this interceptor adds X-Skip-DYM
  // to the first outbound hawksearch proxy call so the server skips the DYM retry.

  (function applySkipDymInterceptor() {
    if (!sessionStorage.getItem('hawksearch_skip_dym')) return;
    sessionStorage.removeItem('hawksearch_skip_dym');
    var origFetch = window.fetch;
    var applied = false;
    window.fetch = function (url, options) {
      if (!applied && typeof url === 'string' && url.indexOf('/api/hawksearch/') !== -1) {
        applied = true;
        options = options || {};
        if (!options.headers) {
          options.headers = { 'X-Skip-DYM': '1' };
        } else if (options.headers instanceof Headers) {
          options.headers.append('X-Skip-DYM', '1');
        } else {
          options.headers['X-Skip-DYM'] = '1';
        }
      }
      return origFetch.call(this, url, options);
    };
  })();

  // ─── Shadow DOM Utilities ────────────────────────────────────────────────────

  /**
   * jQuery/querySelector do not pierce shadow roots; HawkSearch templates render inside shadow trees.
   */
  function querySelectorAllDeep(selector) {
    var acc = [];
    function walk(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll(selector).forEach(function (el) { acc.push(el); });
      var candidates = root.querySelectorAll("*");
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].shadowRoot) walk(candidates[i].shadowRoot);
      }
    }
    walk(document);
    return acc;
  }

  /** Collect all shadow-tree instances of a given custom element tag. */
  function queryAllHawksearchHosts(tagName) {
    var acc = [];
    function walk(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll(tagName).forEach(function (el) { acc.push(el); });
      var candidates = root.querySelectorAll("*");
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].shadowRoot) walk(candidates[i].shadowRoot);
      }
    }
    walk(document);
    return acc;
  }

  /**
   * Find every hawksearch-sorting host. document.querySelectorAll does NOT pierce shadow roots;
   * sorting lives inside hawksearch-search-results (custom template) shadow trees.
   */
  function queryAllHawksearchSortingHosts() {
    return queryAllHawksearchHosts("hawksearch-sorting");
  }

  function queryAllHawksearchPageSizeHosts() {
    return queryAllHawksearchHosts("hawksearch-page-size");
  }

  /**
   * Outer column wrapper in custom-search-results (the one with mobile position:fixed).
   * Clicks on .close-filter live in hawksearch-facets-list shadow — getRootNode() would target the inner
   * aside.product-filters, which does not get the slide-out CSS; always resolve via search-results host.
   */
  function queryAllHawksearchSearchResultsHosts() {
    return queryAllHawksearchHosts("hawksearch-search-results");
  }

  // ─── Auth / Login Helpers ────────────────────────────────────────────────────

  function getLogin() {
    return $('hawksearch-search-results').attr('data-login');
  }

  function getJobListPermission() {
    return $('hawksearch-search-results').attr('data-permission');
  }

  function getVersion() {
    return $('hawksearch-search-results').attr('data-version') || '1';
  }

  function isLoggedIn() {
    return getLogin() === 'True';
  }

  function showLoginPopup() {
    $('.login-popup').fadeIn();
    $('.login').fadeIn();
    $('.login-popup .dialog .close-dialog').show();
  }

  function antiForgeryRefresh(id) {
    $.ajax({
      url: '/login/RefreshToken',
      type: 'GET',
      dataType: 'json',
      beforeSend: function (xhr) { xhr.setRequestHeader('Content-Type', 'application/json'); },
      success: function () {},
      complete: function (data) { $(id).html(data.responseText); },
      error: function () {},
    });
  }

  /** Same behaviour as genericHelper.checkIsLoggedIn (used by usePurchaseHistory). */
  async function checkIsLoggedInApi() {
    try {
      var response = await fetch('/api/checklogin', {
        method: 'GET',
        headers: {
          RequestVerificationToken: $("#checkloginApi [name='__RequestVerificationToken']").val(),
        },
      });
      if (response.ok) {
        var data = await response.json();
        antiForgeryRefresh('#checkloginApi');
        if (data.StatusCode === 200) return true;
      }
    } catch (error) {
      console.error('Network error or request failed:', error);
    }
    return false;
  }

  // ─── Product URL Helpers ─────────────────────────────────────────────────────

  /** Mirrors productHelper.productNameToSlug */
  function productNameToSlug(pname) {
    if (pname == null) return '';
    var name = String(pname);
    name = name.replace(/[^\w\d]/gi, '-');
    name = name.replace(/[ ]/g, '-');
    name = name.replace(/-+/g, '-');
    return name.toLowerCase();
  }

  /** Mirrors productHelper.makeProductUrl */
  function makeProductUrl(product) {
    var PRODUCT_STATE_ONLINE = 'ONLINE';
    product = product || {};
    var isOnline = product.productStatus === PRODUCT_STATE_ONLINE;
    if (!isOnline) return '';
    return '/p/' + (productNameToSlug(product.productName) || '') + '/' + (product.productNumber || '');
  }

  // ─── Session Cache: Purchase History ────────────────────────────────────────

  function clearPurchaseHistoryStorage() {
    sessionStorage.removeItem(PURCHASE_HISTORY_STORAGE_KEY);
  }

  async function fetchPurchaseHistoryFromApi() {
    var params = JSON.stringify({
      current: 1,
      size: 10 * 365 * 25,
      months: 10 * 12,
      query: '',
      orderByFrequency: false,
    });
    try {
      var response = await fetch(window.location.origin + '/api/RecentBuys', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          RequestVerificationToken: $("#checkloginApi [name='__RequestVerificationToken']").val(),
        },
        body: params,
      });
      if (response.ok) {
        var data = await response.json();
        if (data && data.results) return data.results || [];
        if (data && data.ErrorMessage) console.error(data.ErrorMessage);
      }
    } catch (error) {
      console.error('An error has occurred while fetching Purchase History', error);
    }
    return null;
  }

  /**
   * Non-React equivalent of usePurchaseHistory: same storage key, TTL, API, and mapping.
   * @param {boolean} isEnabled — when false, resolves to [] without calling the API.
   * @returns {Promise<Array<{ productNumber, productUrl, lastPurchaseDate }>>}
   */
  async function getPurchaseHistory(isEnabled) {
    if (!isEnabled) return [];

    var loggedIn = await checkIsLoggedInApi();
    if (!loggedIn) {
      clearPurchaseHistoryStorage();
      return [];
    }

    var storedHistoryStr = sessionStorage.getItem(PURCHASE_HISTORY_STORAGE_KEY);
    var storedHistory = storedHistoryStr ? JSON.parse(storedHistoryStr) : null;

    var newHistory = storedHistory && storedHistory.data ? storedHistory.data : [];
    var newUpdatedAt = storedHistory && storedHistory.updatedAt ? storedHistory.updatedAt : new Date().toISOString();
    var isExpired = !storedHistory || !storedHistory.updatedAt ||
      new Date(storedHistory.updatedAt) < new Date(Date.now() - PURCHASE_HISTORY_EXPIRY_MS);

    if (isExpired) {
      var data = await fetchPurchaseHistoryFromApi();
      if (data) {
        newHistory = Array.isArray(data)
          ? data.map(function (p) {
              return { productNumber: p.productNumber, productUrl: makeProductUrl(p), lastPurchaseDate: p.lastPurchaseDate };
            })
          : [];
        newUpdatedAt = new Date().toISOString();
        sessionStorage.setItem(PURCHASE_HISTORY_STORAGE_KEY, JSON.stringify({ data: newHistory, updatedAt: newUpdatedAt }));
      } else {
        clearPurchaseHistoryStorage();
        return [];
      }
    }

    return newHistory;
  }

  // ─── Session Cache: Hierarchy ────────────────────────────────────────────────

  function clearHierarchyStorage() {
    sessionStorage.removeItem(HAWKSEARCH_HIERARCHY_STORAGE_KEY);
  }

  async function fetchHierarchyFromApi() {
    try {
      var tokenEl = document.querySelector("#hawksearchApi [name='__RequestVerificationToken']");
      var response = await fetch(window.location.origin + '/api/hawksearch/hierarchy', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          RequestVerificationToken: tokenEl ? tokenEl.value : '',
        },
      });
      if (response.ok) return await response.json();
    } catch (error) {
      console.error('An error has occurred while fetching HawkSearch hierarchy', error);
    }
    return null;
  }

  /**
   * Fetches and sessionStorage-caches the HawkSearch hierarchy (10-minute TTL).
   * @returns {Promise<Array<{ Field: string, Value: string, Path: string, HierarchyId: string }>>}
   */
  async function getHierarchy() {
    var storedStr = sessionStorage.getItem(HAWKSEARCH_HIERARCHY_STORAGE_KEY);
    var stored = storedStr ? JSON.parse(storedStr) : null;

    var newList = stored && stored.data ? stored.data : [];
    var newUpdatedAt = stored && stored.updatedAt ? stored.updatedAt : new Date().toISOString();
    var isExpired = !stored || !stored.updatedAt ||
      new Date(stored.updatedAt) < new Date(Date.now() - HAWKSEARCH_HIERARCHY_EXPIRY_MS);

    if (isExpired) {
      var data = await fetchHierarchyFromApi();
      if (data) {
        newList = Array.isArray(data) ? data : [];
        newUpdatedAt = new Date().toISOString();
        sessionStorage.setItem(HAWKSEARCH_HIERARCHY_STORAGE_KEY, JSON.stringify({ data: newList, updatedAt: newUpdatedAt }));
      } else {
        clearHierarchyStorage();
        return [];
      }
    }

    return newList;
  }

  // ─── Tooltip UI ──────────────────────────────────────────────────────────────

  function onProdCodeMouseOver(e) {
    var content = 'Middy’s Part Number (Product Code)';
    var el = (e && e.currentTarget) || this;
    if (!el) return;
    var size = Math.round(el.getBoundingClientRect().width);
    el.setAttribute('data-size', size + 'px');

    var tooltip = document.createElement('span');
    tooltip.className = 'prod-tooltip';
    tooltip.style.left = ((size - 230) / 2) + 'px';
    tooltip.textContent = content;
    el.appendChild(tooltip);
  }

  function onProdCodeMouseOut(e) {
    var el = (e && e.currentTarget) || this;
    var t = (e && e.target) || el;
    if (!el) return;
    var parent = t && t.parentElement;
    if (!parent || !parent.classList.contains('prod-code')) {
      var tooltip = el.querySelector('.prod-tooltip');
      if (tooltip) tooltip.remove();
    }
  }

  // ─── Filter / Facet UI ───────────────────────────────────────────────────────

  function clearFilters(event) {
    event.preventDefault();

    function run() {
      if (
        typeof window.HawkSearch === "undefined" ||
        !HawkSearch.services ||
        !HawkSearch.services.search ||
        typeof HawkSearch.services.search.getRequestFromUrl !== "function" ||
        typeof HawkSearch.services.search.search !== "function"
      ) {
        return;
      }

      // Clear facet/filter state by clearing the URL params that the HawkSearch UI reads from,
      // then force a fresh search request based on the cleaned URL.
      var currentUrl = new URL(window.location.href);
      var qKey =
        (HawkSearch.services.search.queryStringParams &&
          (HawkSearch.services.search.queryStringParams.query ||
            HawkSearch.services.search.queryStringParams.keyword)) ||
        "q";
      var qVal = currentUrl.searchParams.get(qKey);

      var requestType = currentUrl.searchParams.get("requestType");
      currentUrl.search = "";
      if (qVal) currentUrl.searchParams.set(qKey, qVal);
      if (requestType) currentUrl.searchParams.set("requestType", requestType);
      window.history.replaceState({}, "", currentUrl.toString());

      var req = HawkSearch.services.search.getRequestFromUrl();
      HawkSearch.services.search.search(req);
    }

    // If HawkSearch isn't ready yet, run after it loads.
    if (typeof window.HawkSearch === "undefined") {
      addEventListener("hawksearch:loaded", function () { run(); }, { once: true });
      return;
    }
    run();
  }

  /**
   * Toggle HawkSearch facet filter panel open/closed.
   * @param {Event|HTMLElement} eventOrEl - Click event (use event from onclick or delegated handler) or the .filter-link element
   */
  function toggleFilterFacet(eventOrEl) {
    var $link =
      eventOrEl && eventOrEl.jquery
        ? eventOrEl
        : $(eventOrEl && eventOrEl.currentTarget ? eventOrEl.currentTarget : eventOrEl).closest(".filter-link");
    if (!$link.length) return;
    if (eventOrEl && typeof eventOrEl.preventDefault === "function") eventOrEl.preventDefault();
    $link.parent().toggleClass("open-filter");
  }

  $(document).on("click", ".filter-link", function (e) { toggleFilterFacet(e); });

  // ─── Facet Open-State Preservation Across Search Refreshes ──────────────────

  var openFacetTitles = [];
  var restoreFacetTimer = null;
  var restoreFacetRetryCount = 0;
  var RESTORE_FACET_MAX_RETRIES = 20;
  var hawksearchFirstSearchDone = false;

  function isCategoryLandingPage() {
    var el = document.querySelector('hawksearch-search-results');
    return !!(el && el.getAttribute('data-is-category-landing-page') === 'True');
  }

  function hasBrandFacetFilter() {
    try {
      var facets = HawkSearch.searchRequest && HawkSearch.searchRequest.facets;
      if (!facets) return false;
      return Object.keys(facets).some(function (key) {
        return key.toLowerCase() === 'brand_name' && facets[key] && facets[key].length > 0;
      });
    } catch (e) { return false; }
  }

  function captureOpenFacetTitles() {
    openFacetTitles = [];
    querySelectorAllDeep('.open-filter .filter-link').forEach(function (el) {
      var title = el.textContent.trim();
      if (title) openFacetTitles.push(title);
    });
    if (!hawksearchFirstSearchDone) {
      if (openFacetTitles.indexOf('Category') === -1) {
        openFacetTitles.push('Category');
      }
      if (hasBrandFacetFilter() && openFacetTitles.indexOf('Brand') === -1) {
        openFacetTitles.push('Brand');
      }
    }
    hawksearchFirstSearchDone = true;
  }

  function restoreOpenFacets() {
    if (!openFacetTitles.length) return;
    var links = querySelectorAllDeep('.filter-link');
    if (!links.length) {
      if (restoreFacetRetryCount < RESTORE_FACET_MAX_RETRIES) {
        restoreFacetRetryCount++;
        restoreFacetTimer = setTimeout(restoreOpenFacets, 50);
      }
      return;
    }
    links.forEach(function (el) {
      if (openFacetTitles.indexOf(el.textContent.trim()) === -1) return;
      var $parent = $(el).parent();
      if (!$parent.hasClass('open-filter')) {
        $parent.addClass('open-filter');
      }
    });
  }

  function scheduleRestoreOpenFacets() {
    clearTimeout(restoreFacetTimer);
    restoreFacetRetryCount = 0;
    restoreFacetTimer = setTimeout(restoreOpenFacets, 100);
  }

  // ─── Facet Selection / Page Reset ───────────────────────────────────────────

  function getSearchPageParamKey() {
    if (
      typeof window.HawkSearch !== 'undefined' &&
      HawkSearch.services &&
      HawkSearch.services.search &&
      HawkSearch.services.search.queryStringParams &&
      HawkSearch.services.search.queryStringParams.page
    ) {
      return HawkSearch.services.search.queryStringParams.page;
    }
    return 'page';
  }

  function resetSearchPageInUrl() {
    var url = new URL(window.location.href);
    var pageKey = getSearchPageParamKey();
    if (!url.searchParams.has(pageKey)) return;
    url.searchParams.delete(pageKey);
    window.history.replaceState({}, '', url.toString());
    if (typeof window.HawkSearch !== 'undefined' && HawkSearch.searchRequest) {
      HawkSearch.searchRequest.page = 1;
    }
  }

  function isFacetSelectionTarget(el) {
    if (!el || !el.getAttribute) return false;
    if (el.id === 'excludeOutOfStock') return true;
    if (el.hasAttribute('hawksearch-facet-value')) return true;
    if (el.hasAttribute('hawksearch-facet-value-include')) return true;
    if (el.hasAttribute('hawksearch-facet-value-exclude')) return true;
    if (el.hasAttribute('hawksearch-facet-value-toggle')) return true;
    return false;
  }

  function isFacetSelectionEvent(e) {
    if (e.composedPath) {
      var path = e.composedPath();
      for (var i = 0; i < path.length; i++) {
        if (isFacetSelectionTarget(path[i])) return true;
      }
      return false;
    }
    return isFacetSelectionTarget(e.target);
  }

  var facetSelectionPageResetWired = false;

  function wireFacetSelectionPageReset() {
    if (facetSelectionPageResetWired) return;
    facetSelectionPageResetWired = true;
    // Capture phase — run before HawkSearch handlers so URL/page state is reset first.
    document.addEventListener('click', function (e) {
      if (!isFacetSelectionEvent(e)) return;
      resetSearchPageInUrl();
    }, true);
    document.addEventListener('change', function (e) {
      if (!isFacetSelectionEvent(e)) return;
      resetSearchPageInUrl();
    }, true);
  }

  // ─── Out-of-Stock Filter ─────────────────────────────────────────────────────

  var excludeOutOfStockRetryTimer = null;
  var excludeOutOfStockRetryCount = 0;

  function onExcludeOutOfStockChange(cb) {
    resetSearchPageInUrl();
    var url = new URL(window.location.href);
    url.searchParams.set('stock', cb.checked ? 'true' : 'false');
    window.history.replaceState({}, '', url.toString());
    if (
      typeof window.HawkSearch !== 'undefined' &&
      HawkSearch.services &&
      HawkSearch.services.search &&
      typeof HawkSearch.services.search.getRequestFromUrl === 'function' &&
      typeof HawkSearch.services.search.search === 'function'
    ) {
      var req = HawkSearch.services.search.getRequestFromUrl();
      HawkSearch.services.search.search(req);
    }
  }

  function applyExcludeOutOfStockState() {
    var shouldBeChecked = new URLSearchParams(window.location.search).get('stock') === 'true';
    querySelectorAllDeep('#excludeOutOfStock').forEach(function (cb) {
      cb.checked = shouldBeChecked;
      if (!cb.dataset.stockSyncWired) {
        cb.dataset.stockSyncWired = '1';
        cb.addEventListener('change', function () { onExcludeOutOfStockChange(cb); });
      }
    });
    // Always continue retrying: hawksearch:after-search-executed fires before shadow DOM
    // re-renders, so the old element is found first. Continuing catches the new element.
    if (excludeOutOfStockRetryCount < EXCLUDE_OOS_MAX_RETRIES) {
      excludeOutOfStockRetryCount++;
      excludeOutOfStockRetryTimer = setTimeout(applyExcludeOutOfStockState, 50);
    }
  }

  function scheduleApplyExcludeOutOfStockState() {
    clearTimeout(excludeOutOfStockRetryTimer);
    excludeOutOfStockRetryCount = 0;
    applyExcludeOutOfStockState();
  }

  // ─── Results Summary / No Results Message ────────────────────────────────────

  var hawkNoResultsTimer = null;
  var hawkLastSearchResponse = null; // raw API response from hawksearch:after-search-executed detail

  function getSearchQuery() {
    return (hawkLastSearchResponse && hawkLastSearchResponse.AdjustedKeyword) || (hawkLastSearchResponse && hawkLastSearchResponse.Keyword) || '';
  }

  function getHawkSearchTotalHits() {
    try {
      var hits = hawkLastSearchResponse && hawkLastSearchResponse.Pagination && hawkLastSearchResponse.Pagination.NofResults;
      return typeof hits === 'number' ? hits : null;
    } catch (e) {
      return null;
    }
  }

  function redirectToResultsNotFound(query) {
    var url = '/ResultsNotFound';
    if (query) {
      url += '?query=' + encodeURIComponent(query);
    }
    window.location.replace(url);
  }

  function updateResultsMessages(itemsFound) {
    var summary = document.getElementById('hawkResultsSummary');
    var resultsEl = document.querySelector('hawksearch-search-results');
    var query = getSearchQuery();

    if (!itemsFound) {
      if (query) {
        redirectToResultsNotFound(query);
        return;
      }
      if (summary) {
        summary.textContent = 'We couldn’t find any products.';
        summary.style.display = 'block';
      }
      if (resultsEl) resultsEl.style.display = 'none';
    } else if (query) {
      // Query page with results — show count
      var total = getHawkSearchTotalHits();
      var count = total;
      if (summary) {
        summary.textContent = count + " results for '" + query + "'";
        summary.style.display = 'block';
        var existingDym = document.getElementById('hawkResultsDymMsg');
        if (existingDym) existingDym.remove();
        var existingDymLink = document.getElementById('hawkResultsDymLink');
        if (existingDymLink) existingDymLink.remove();
        var originalKeyword = hawkLastSearchResponse && hawkLastSearchResponse.OriginalKeyword;
        if (originalKeyword) {
          var pMsg = document.createElement('p');
          pMsg.id = 'hawkResultsDymMsg';
          pMsg.style.margin = '8px 0';
          pMsg.appendChild(document.createTextNode("No results found for '" + originalKeyword + "'. Showing results for '" + query + "' instead."));
          var link = document.createElement('a');
          link.href = '#';
          link.textContent = "Search for '" + originalKeyword + "'";
          link.addEventListener('click', function (e) {
            e.preventDefault();
            sessionStorage.setItem('hawksearch_skip_dym', '1');
            var params = new URLSearchParams(window.location.search);
            params.set('query', originalKeyword);
            window.location.search = params.toString();
          });
          var pLink = document.createElement('p');
          pLink.id = 'hawkResultsDymLink';
          pLink.style.margin = '8px 0';
          pLink.appendChild(link);
          summary.insertAdjacentElement('afterend', pMsg);
          pMsg.insertAdjacentElement('afterend', pLink);
        }
      }
      if (resultsEl) resultsEl.style.display = '';
    } else {
      // Non-query page with results — hide summary
      if (summary) summary.style.display = 'none';
      if (resultsEl) resultsEl.style.display = '';
    }
  }

  function resetResultsMessages() {
    var summary = document.getElementById('hawkResultsSummary');
    if (summary) summary.style.display = 'none';
    var dymMsg = document.getElementById('hawkResultsDymMsg');
    if (dymMsg) dymMsg.remove();
    var dymLink = document.getElementById('hawkResultsDymLink');
    if (dymLink) dymLink.remove();
    var errorEl = document.getElementById('hawkResultsSummaryError');
    if (errorEl) errorEl.style.display = 'none';
    var resultsEl = document.querySelector('hawksearch-search-results');
    if (resultsEl) resultsEl.style.display = '';
  }

  function showSearchErrorMessage() {
    var summary = document.getElementById('hawkResultsSummary');
    var errorEl = document.getElementById('hawkResultsSummaryError');
    var resultsEl = document.querySelector('hawksearch-search-results');
    if (summary) summary.style.display = 'none';
    if (errorEl) errorEl.style.display = 'block';
    if (resultsEl) resultsEl.style.display = 'none';
  }

  function scheduleHawkNoResultsCheck() {
    clearTimeout(hawkNoResultsTimer);

    var query = getSearchQuery();
    if (getHawkSearchTotalHits() === 0 && query) {
      redirectToResultsNotFound(query);
      return;
    }

    resetResultsMessages();

    // hawksearch:after-search-executed fires before the shadow DOM re-renders.
    // Check at 300ms; if items are still absent at 600ms treat it as genuine no-results.
    var checks = 0;
    function check() {
      var items = querySelectorAllDeep('hawksearch-search-results-item');
      if (items.length > 0) {
        updateResultsMessages(true);
        return;
      }
      if (++checks < 2) {
        hawkNoResultsTimer = setTimeout(check, 300);
      } else {
        hawkNoResultsTimer = null;
        updateResultsMessages(false);
      }
    }
    hawkNoResultsTimer = setTimeout(check, 300);
  }

  // ─── Mobile Layout ───────────────────────────────────────────────────────────

  var hawksearchMobileAdjustTimer = null;
  var hawksearchMobileAdjustAttempts = 0;
  var hawksearchMobileMoTimer = null;
  var hawksearchMobileFilterHandlersBound = false;
  var hawksearchMobileResizeTimer = null;

  function isHawksearchMobileViewport() {
    if (typeof window.matchMedia === "function") {
      return window.matchMedia("(max-width: 767px)").matches;
    }
    return (window.innerWidth || document.documentElement.clientWidth || 0) < 768;
  }

  /**
   * Sort row: prefer compound selector, plus parent of hawksearch-sorting (same discovery as Select2).
   */
  function getSortWrapElements() {
    var acc = [];
    var seen = [];
    function add(el) {
      if (!el || el.nodeType !== 1) return;
      for (var s = 0; s < seen.length; s++) { if (seen[s] === el) return; }
      seen.push(el);
      acc.push(el);
    }
    var rootResults = document.querySelector("hawksearch-search-results");
    if (rootResults && rootResults.shadowRoot) {
      rootResults.shadowRoot.querySelectorAll(".product-group .sort-wrap").forEach(add);
    }
    querySelectorAllDeep(".product-group .sort-wrap").forEach(add);
    queryAllHawksearchSortingHosts().forEach(function (host) {
      var n = host.parentElement;
      while (n) {
        if (n.classList && n.classList.contains("sort-wrap")) { add(n); break; }
        n = n.parentElement;
      }
    });
    return acc;
  }

  function getMobileFilterPanelElements() {
    var out = [];
    queryAllHawksearchSearchResultsHosts().forEach(function (host) {
      if (!host.shadowRoot) return;
      var panel = host.shadowRoot.querySelector(".product-tiles-block > .product-filters") ||
                  host.shadowRoot.querySelector(".product-tiles-block .product-filters");
      if (panel) out.push(panel);
    });
    return out;
  }

  /**
   * jQuery delegated $(document).on("click", selector) does not match targets inside open shadow roots.
   * Use composedPath (with fallback) so Filters / close work when those nodes live under hawksearch-* shadows.
   */
  function findClickTargetInComposedPath(e, className) {
    if (e.composedPath) {
      var path = e.composedPath();
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el && el.classList && el.classList.contains(className)) return el;
      }
      return null;
    }
    var t = e.target;
    if (t && t.nodeType !== 1) t = t.parentElement;
    return t && t.closest ? t.closest("." + className) : null;
  }

  function wireHawksearchMobileFilterHandlers() {
    if (hawksearchMobileFilterHandlersBound) return;
    hawksearchMobileFilterHandlersBound = true;
    document.addEventListener("click", function (e) {
      var toggle = findClickTargetInComposedPath(e, "filter-view-toggle");
      var closer = findClickTargetInComposedPath(e, "close-filter");
      if (!toggle && !closer) return;
      e.preventDefault();
      var panels = getMobileFilterPanelElements();
      // Shadow DOM may be mid-render — retry once if panel not found yet.
      if (!panels.length) {
        var isToggle = !!toggle;
        setTimeout(function () {
          var retryPanels = getMobileFilterPanelElements();
          if (!retryPanels.length) return;
          if (!isToggle) {
            retryPanels.forEach(function (p) { p.classList.remove("hawksearch-mobile-drawer-open"); });
            return;
          }
          var retryOpen = retryPanels.some(function (p) { return p.classList.contains("hawksearch-mobile-drawer-open"); });
          retryPanels.forEach(function (p) {
            p.classList[retryOpen ? "remove" : "add"]("hawksearch-mobile-drawer-open");
            if (!retryOpen) { restoreOpenFacets(); }
          });
        }, 120);
        return;
      }
      if (closer) {
        panels.forEach(function (p) { p.classList.remove("hawksearch-mobile-drawer-open"); });
        return;
      }
      if (toggle) {
        var isOpen = panels.some(function (p) { return p.classList.contains("hawksearch-mobile-drawer-open"); });
        panels.forEach(function (p) {
          p.classList[isOpen ? "remove" : "add"]("hawksearch-mobile-drawer-open");
          if (!isOpen) { restoreOpenFacets(); }
        });
      }
    }, true);

    // Close the filter panel when a facet value is selected in mobile view.
    // Uses capture so it fires before HawkSearch's own stopPropagation on change events.
    document.addEventListener("click", function (e) {
      if (!isHawksearchMobileViewport()) return;
      var hasFacetValue = false;
      if (e.composedPath) {
        var path = e.composedPath();
        for (var i = 0; i < path.length; i++) {
          var el = path[i];
          if (el && el.hasAttribute && el.hasAttribute("hawksearch-facet-value")) {
            hasFacetValue = true;
            break;
          }
        }
      }
      if (!hasFacetValue) return;
      getMobileFilterPanelElements().forEach(function (p) { p.classList.remove("hawksearch-mobile-drawer-open"); });
    }, true);
  }

  function mobileAdjustments() {
    wireHawksearchMobileFilterHandlers();
    var sortWraps = getSortWrapElements();
    var sidebarLabels = querySelectorAllDeep(".sidebar-head label");
    if (isHawksearchMobileViewport()) {
      sortWraps.forEach(function (sortWrap) {
        if (!sortWrap.querySelector(".filter-view-toggle")) {
          var a = document.createElement("a");
          a.setAttribute("href", "#");
          a.className = "btn filter-view-toggle";
          a.textContent = "Filters";
          sortWrap.insertBefore(a, sortWrap.firstChild);
        }
      });
      sidebarLabels.forEach(function (label) {
        var parent = label.parentElement;
        if (!parent || parent.querySelector(".close-filter")) return;
        var closeA = document.createElement("a");
        closeA.setAttribute("href", "#");
        closeA.className = "close-filter";
        label.insertAdjacentElement("afterend", closeA);
      });
    } else {
      getMobileFilterPanelElements().forEach(function (p) { p.classList.remove("hawksearch-mobile-drawer-open"); });
      querySelectorAllDeep(".product-group .sort-wrap .filter-view-toggle").forEach(function (el) { el.remove(); });
      querySelectorAllDeep(".sidebar-head .close-filter").forEach(function (el) { el.remove(); });
    }
  }

  function scheduleMobileAdjustments() {
    if (hawksearchMobileAdjustTimer) {
      clearTimeout(hawksearchMobileAdjustTimer);
      hawksearchMobileAdjustTimer = null;
    }
    hawksearchMobileAdjustAttempts = 0;
    function attempt() {
      mobileAdjustments();
      hawksearchMobileAdjustAttempts++;
      if (!isHawksearchMobileViewport()) return;
      var wraps = getSortWrapElements();
      var needRetry = wraps.length === 0 || wraps.some(function (w) { return !w.querySelector(".filter-view-toggle"); });
      if (needRetry && hawksearchMobileAdjustAttempts < HAWKSEARCH_MOBILE_ADJUST_MAX) {
        hawksearchMobileAdjustTimer = setTimeout(function () {
          hawksearchMobileAdjustTimer = null;
          attempt();
        }, 120);
      }
    }
    attempt();
  }

  /**
   * HawkSearch re-renders (facets, pagination, etc.) inside the results shadow tree and replaces nodes —
   * the injected Filters link is removed. Body-level MutationObserver does not see subtree changes inside shadow DOM.
   */
  function debouncedScheduleMobileAdjustmentsFromResultsDom() {
    if (hawksearchMobileMoTimer) clearTimeout(hawksearchMobileMoTimer);
    hawksearchMobileMoTimer = setTimeout(function () {
      hawksearchMobileMoTimer = null;
      scheduleMobileAdjustments();
      if (openFacetTitles.length) scheduleRestoreOpenFacets();
    }, 180);
  }

  function ensureSearchResultsMobileObserver(host) {
    if (!host || host.dataset.hawksearchMobileMoAttached === "1") return;
    var frames = 0;
    var maxFrames = 240;
    function tryAttach() {
      if (!host.isConnected || host.dataset.hawksearchMobileMoAttached === "1") return;
      var sr = host.shadowRoot;
      if (!sr) {
        if (++frames > maxFrames) return;
        requestAnimationFrame(tryAttach);
        return;
      }
      host.dataset.hawksearchMobileMoAttached = "1";
      new MutationObserver(function () { debouncedScheduleMobileAdjustmentsFromResultsDom(); })
        .observe(sr, { childList: true, subtree: true });
      debouncedScheduleMobileAdjustmentsFromResultsDom();
    }
    tryAttach();
  }

  function attachHawksearchSearchResultsMobileObservers() {
    queryAllHawksearchSearchResultsHosts().forEach(ensureSearchResultsMobileObserver);
  }

  $(window).on("resize.hawksearchMobile", function () {
    if (hawksearchMobileResizeTimer) clearTimeout(hawksearchMobileResizeTimer);
    hawksearchMobileResizeTimer = setTimeout(function () {
      hawksearchMobileResizeTimer = null;
      mobileAdjustments();
    }, 150);
  });

  // ─── Select2 Integration ─────────────────────────────────────────────────────

  var hawksearchSortingSelect2Debounce = null;
  var hawksearchSort2RetryTimer = null;
  var hawksearchSort2RetryCount = 0;

  var hawksearchPageSizeSelect2Debounce = null;
  var hawksearchPageSize2RetryTimer = null;
  var hawksearchPageSize2RetryCount = 0;

  /**
   * Global select2.min.css does not cross shadow boundaries. The closed-state
   * .select2-container lives next to <select> inside the shadow tree — inject the same stylesheet.
   * Dropdown uses dropdownParent: body and keeps using document styles.
   */
  function resolveSelect2StylesheetHref() {
    var ver = getVersion();
    var vParam = '?v=' + ver;
    var existing = document.querySelector('link[rel="stylesheet"][href*="select2"]');
    if (existing && existing.href) return existing.href;
    var scr = document.querySelector('script[src*="select2"]');
    if (scr && scr.src) {
      return scr.src
        .replace(/select2\.min\.js/i, "select2.min.css")
        .replace(/\/js\//i, "/css/")
        + vParam;
    }
    try {
      return new URL("assets/css/select2.min.css", window.location.href).href + vParam;
    } catch (e) {
      return "/assets/css/select2.min.css" + vParam;
    }
  }

  function ensureSelect2StylesInShadow(shadowRoot) {
    if (!shadowRoot) return;
    if (!shadowRoot.querySelector("link[data-hawksearch-select2-css]")) {
      var link = document.createElement("link");
      link.setAttribute("rel", "stylesheet");
      link.setAttribute("href", resolveSelect2StylesheetHref());
      link.setAttribute("data-hawksearch-select2-css", "1");
      shadowRoot.insertBefore(link, shadowRoot.firstChild);
    }
    if (!shadowRoot.querySelector("style[data-hawksearch-select2-theme]")) {
      var theme = document.createElement("style");
      theme.setAttribute("data-hawksearch-select2-theme", "1");
      theme.textContent = ".select2-container{min-width:175px;margin-bottom:13px;}select{width:auto;}@media screen and (max-width: 767px), print {.select2-container{margin-bottom:0;}}";
      shadowRoot.appendChild(theme);
    }
  }

  /**
   * Wire Select2 onto a hawksearch shadow host's <select>.
   * @param {HTMLElement} host - Shadow host element
   * @param {string} selectAttr - Attribute to identify the target <select> (e.g. 'hawksearch-sort')
   * @param {string} eventNs - Namespace suffix for the select2:select handler
   * @returns {boolean} true if Select2 was applied
   */
  function wireHawksearchSelect2(host, selectAttr, eventNs) {
    if (!host || !host.shadowRoot) return false;
    var select = host.shadowRoot.querySelector('select[' + selectAttr + '], select');
    if (!select) return false;
    var $sel = $(select);
    if ($sel.data("select2")) return true;
    ensureSelect2StylesInShadow(host.shadowRoot);
    $sel.select2({
      minimumResultsForSearch: Infinity,
      width: "style",
      dropdownParent: $(document.body),
    });
    $sel.off('select2:select.' + eventNs).on('select2:select.' + eventNs, function () {
      select.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
      select.dispatchEvent(new Event("input", { bubbles: true, composed: true }));
    });
    return true;
  }

  /** @returns {boolean} true if Select2 was applied */
  function wireHawksearchSortingSelect2(host) {
    return wireHawksearchSelect2(host, 'hawksearch-sort', 'hawksearchSort2');
  }

  /** @returns {boolean} true if Select2 was applied */
  function wireHawksearchPageSizeSelect2(host) {
    return wireHawksearchSelect2(host, 'hawksearch-page-size', 'hawksearchPageSize2');
  }

  /**
   * Attach a MutationObserver to a shadow host, retrying via rAF until the shadow root appears.
   * @param {HTMLElement} host
   * @param {string} datasetFlag - host.dataset key to prevent double-attach
   * @param {string} selectAttr - Attribute selector for the <select>
   * @param {Function} scheduleInit - Scheduler to call when shadow DOM changes
   */
  function ensureShadowHostObserver(host, datasetFlag, selectAttr, scheduleInit) {
    if (!host || host.dataset[datasetFlag]) return;
    if (host.shadowRoot) {
      host.dataset[datasetFlag] = "1";
      new MutationObserver(function () {
        if (!host.shadowRoot) return;
        var sel = host.shadowRoot.querySelector('select[' + selectAttr + '], select');
        if (sel && $(sel).data("select2")) return;
        scheduleInit();
      }).observe(host.shadowRoot, { childList: true, subtree: true });
      scheduleInit();
      return;
    }
    // Shadow root not attached yet — wait via rAF
    var frames = 0;
    var maxFrames = 180;
    function waitForShadow() {
      if (!host.isConnected) return;
      if (host.shadowRoot) { ensureShadowHostObserver(host, datasetFlag, selectAttr, scheduleInit); return; }
      if (++frames > maxFrames) return;
      requestAnimationFrame(waitForShadow);
    }
    requestAnimationFrame(waitForShadow);
  }

  function ensureShadowRootObserver(host) {
    ensureShadowHostObserver(host, 'hawksearchSort2ShadowObs', 'hawksearch-sort', scheduleInitHawksearchSortingSelect2);
  }

  function ensurePageSizeShadowRootObserver(host) {
    ensureShadowHostObserver(host, 'hawksearchPageSize2ShadowObs', 'hawksearch-page-size', scheduleInitHawksearchPageSizeSelect2);
  }

  function attachHawksearchSortingShadowObservers() {
    queryAllHawksearchSortingHosts().forEach(ensureShadowRootObserver);
  }

  function attachHawksearchPageSizeShadowObservers() {
    queryAllHawksearchPageSizeHosts().forEach(ensurePageSizeShadowRootObserver);
  }

  function initHawksearchSortingSelect2() {
    if (typeof window.jQuery === "undefined" || !$.fn.select2) {
      scheduleHawksearchSort2Retry();
      return;
    }
    attachHawksearchSortingShadowObservers();
    var hosts = queryAllHawksearchSortingHosts();
    var wired = 0;
    hosts.forEach(function (host) { if (wireHawksearchSortingSelect2(host)) wired++; });
    if (hosts.length > 0 && wired < hosts.length) {
      scheduleHawksearchSort2Retry();
    } else {
      hawksearchSort2RetryCount = 0;
    }
  }

  function scheduleHawksearchSort2Retry() {
    if (hawksearchSort2RetryCount >= HAWKSEARCH_SORT2_MAX_RETRIES) return;
    hawksearchSort2RetryCount++;
    clearTimeout(hawksearchSort2RetryTimer);
    hawksearchSort2RetryTimer = setTimeout(function () {
      hawksearchSort2RetryTimer = null;
      scheduleInitHawksearchSortingSelect2();
    }, 120);
  }

  function scheduleInitHawksearchSortingSelect2() {
    if (hawksearchSortingSelect2Debounce) clearTimeout(hawksearchSortingSelect2Debounce);
    hawksearchSortingSelect2Debounce = setTimeout(function () {
      hawksearchSortingSelect2Debounce = null;
      initHawksearchSortingSelect2();
    }, 150);
  }

  function initHawksearchPageSizeSelect2() {
    if (typeof window.jQuery === "undefined" || !$.fn.select2) {
      scheduleHawksearchPageSize2Retry();
      return;
    }
    attachHawksearchPageSizeShadowObservers();
    var hosts = queryAllHawksearchPageSizeHosts();
    var wired = 0;
    hosts.forEach(function (host) { if (wireHawksearchPageSizeSelect2(host)) wired++; });
    if (hosts.length > 0 && wired < hosts.length) {
      scheduleHawksearchPageSize2Retry();
    } else {
      hawksearchPageSize2RetryCount = 0;
    }
  }

  function scheduleHawksearchPageSize2Retry() {
    if (hawksearchPageSize2RetryCount >= HAWKSEARCH_PAGESIZE2_MAX_RETRIES) return;
    hawksearchPageSize2RetryCount++;
    clearTimeout(hawksearchPageSize2RetryTimer);
    hawksearchPageSize2RetryTimer = setTimeout(function () {
      hawksearchPageSize2RetryTimer = null;
      scheduleInitHawksearchPageSizeSelect2();
    }, 120);
  }

  function scheduleInitHawksearchPageSizeSelect2() {
    if (hawksearchPageSizeSelect2Debounce) clearTimeout(hawksearchPageSizeSelect2Debounce);
    hawksearchPageSizeSelect2Debounce = setTimeout(function () {
      hawksearchPageSizeSelect2Debounce = null;
      initHawksearchPageSizeSelect2();
    }, 150);
  }

  // ─── Focus First Search Result ────────────────────────────────────────────────

  var focusFirstResultRetryTimer = null;
  var focusFirstResultRetryCount = 0;
  var hawksearchSearchExecutedCount = 0;

  function focusFirstSearchResult() {
    var items = querySelectorAllDeep('hawksearch-search-results-item');
    if (items.length > 0) {
      var firstItem = items[0];
      var link = firstItem.shadowRoot && (
        firstItem.shadowRoot.querySelector('a[hawksearch-link]') ||
        firstItem.shadowRoot.querySelector('a')
      );
      if (link) {
        link.focus({ preventScroll: false });
        return;
      }
    }
    if (focusFirstResultRetryCount < FOCUS_FIRST_RESULT_MAX_RETRIES) {
      focusFirstResultRetryCount++;
      focusFirstResultRetryTimer = setTimeout(focusFirstSearchResult, 50);
    }
  }

  function scheduleFocusFirstSearchResult() {
    clearTimeout(focusFirstResultRetryTimer);
    focusFirstResultRetryCount = 0;
    hawksearchSearchExecutedCount++;
    if (hawksearchSearchExecutedCount <= 1) return; // Skip initial page load — only refocus after user-triggered searches
    focusFirstSearchResult();
  }

  // ─── Warning Popup ───────────────────────────────────────────────────────────

  var hawkWarningConfirmCallback = null;
  var hawkSoftWarnedInputs = new WeakSet();
  var hawkWarningInput = null;
  var hawkWarningOldValue = null;

  function showWarningPopup(type, message, confirmCallback) {
    hawkWarningConfirmCallback = confirmCallback || null;
    var msgEl = document.getElementById('warningpopup-message');
    var cancelEl = document.getElementById('delete-cancel');
    var yesEl = document.getElementById('delete-yes');
    if (msgEl) msgEl.textContent = message;
    if (cancelEl) cancelEl.style.display = type === 'soft' ? '' : 'none';
    if (yesEl) yesEl.textContent = type === 'hard' ? 'Ok' : 'Yes';
    $('#warningpopup').show();
  }

  function handleCancelPopupClick() {
    if (hawkWarningInput && hawkWarningOldValue !== null) {
      hawkWarningInput.value = hawkWarningOldValue;
      hawkSoftWarnedInputs.delete(hawkWarningInput);
    }
    hawkWarningInput = null;
    hawkWarningOldValue = null;
    hawkWarningConfirmCallback = null;
    $('#warningpopup').hide();
  }

  function handleWarningPopupClick() {
    hawkWarningInput = null;
    hawkWarningOldValue = null;
    if (hawkWarningConfirmCallback) hawkWarningConfirmCallback();
    hawkWarningConfirmCallback = null;
    $('#warningpopup').hide();
  }

  // ─── Cart Actions ────────────────────────────────────────────────────────────

  function resetAddToCartInCartWrap(el) {
    var cartWrap = el.closest('.cart-wrap');
    if (!cartWrap) return;
    var btn = cartWrap.querySelector('.add-to-cart');
    if (btn && btn.classList.contains('added')) {
      btn.classList.remove('added');
      btn.textContent = 'Add to cart';
    }
  }

  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.classList) continue;
      if (el.classList.contains('decrease')) {
        var input = el.nextElementSibling;
        var v = parseInt(input.value, 10);
        if (v > parseInt(input.min, 10)) {
          input.value = v - 1;
          resetAddToCartInCartWrap(el);
        }
        return;
      }
      if (el.classList.contains('increase')) {
        var input = el.previousElementSibling;
        var oldVal = parseInt(input.value, 10);
        var newVal = oldVal + 1;
        if (newVal > 99999) {
          showWarningPopup('hard', "You have reached the maximum limit. Quantity can not be more than 99,999.");
          return;
        }
        input.value = newVal;
        resetAddToCartInCartWrap(el);
        if (newVal > 9999 && !hawkSoftWarnedInputs.has(input)) {
          hawkSoftWarnedInputs.add(input);
          hawkWarningInput = input;
          hawkWarningOldValue = oldVal;
          showWarningPopup('soft', "Alert you have added more than 9999 items.");
        }
        return;
      }
    }
  }, true);

  document.addEventListener('input', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.name === 'qty-count') {
        var min = parseInt(el.min, 10) || 1;
        var val = parseInt(el.value, 10);
        if (!isNaN(val) && val < min) { el.value = min; val = min; }
        if (!isNaN(val)) {
          if (val > 99999) {
            el.value = 99999;
            showWarningPopup('hard', "You have reached the maximum limit. Quantity can not be more than 99,999.");
          } else if (val > 9999 && !hawkSoftWarnedInputs.has(el)) {
            hawkSoftWarnedInputs.add(el);
            hawkWarningInput = el;
            hawkWarningOldValue = min;
            showWarningPopup('soft', "Alert you have added more than 9999 items.");
          }
        }
        resetAddToCartInCartWrap(el);
        return;
      }
    }
  }, true);

  function addToCart(el) {
    var prontoCode = el.getAttribute('data-productcode') || '';
    var productName = el.getAttribute('data-productname') || '';
    var price = el.getAttribute('data-productprice') || '';
    var cartWrap = el.closest('.cart-wrap');
    var qtyInput = cartWrap && cartWrap.querySelector('.qty-control input');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;

    var tokenVal = (document.querySelector("#checkloginApi [name='__RequestVerificationToken']") || {}).value || '';
    fetch('/api/checklogin', { method: 'GET', headers: { 'RequestVerificationToken': tokenVal } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        _AntiForgeryToken('#checkloginApi');
        if (data.StatusCode == 200) {
          _hawksearchDoAddToCart(prontoCode, qty, price, el);
        } else {
          localStorage.setItem('cartProntoCode', prontoCode);
          localStorage.setItem('cartProntoCodeQTY', qty);
          localStorage.setItem('cartProntoCodePrice', price);
          localStorage.setItem('cartProntoName', productName);
          location.reload();
        }
      })
      .catch(function (err) { console.error(err); });
  }

  function _hawksearchDoAddToCart(prontoCode, qty, price, btn) {
    var tokenVal = (document.querySelector("#checkloginApi [name='__RequestVerificationToken']") || {}).value || '';
    var payload = 'prontocode=' + encodeURIComponent(prontoCode) + '&quantity=' + qty;
    if (price) payload += '&price=' + encodeURIComponent(price);

    $.ajax({
      url: '/api/cart/AddToItem?' + payload,
      type: 'GET',
      dataType: 'json',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('RequestVerificationToken', tokenVal);
      },
      success: function (data) {
        if (data.statusCode && data.statusCode == 200) {
          localStorage.removeItem('cartProntoCode');
          localStorage.removeItem('cartProntoCodeQTY');
          localStorage.removeItem('cartProntoName');
          if (btn) {
            btn.classList.add('added');
            btn.textContent = 'Added';
            setTimeout(function () {
              btn.classList.remove('added');
              btn.textContent = 'Add to cart';
            }, 3000);
          }
          CheckShoppingCart();
          if (window.middysSmartSearch && typeof window.middysSmartSearch.trackHawkSearchAddToCart === 'function') {
            window.middysSmartSearch.trackHawkSearchAddToCart(String(prontoCode), qty, parseFloat(price) || 0, 'AUD');
          }
        }
      },
      complete: function () { _AntiForgeryToken('#checkloginApi'); },
      error: function () {}
    });
  }

  async function addToJoblist(elOrEvent) {
    var el = (elOrEvent && elOrEvent.currentTarget) || (elOrEvent && elOrEvent.target) || elOrEvent;
    var productName = el.getAttribute('data-productname') || '';
    var prontoCode = el.getAttribute('data-productcode') || '';
    var qtyParsed = parseInt(el.getAttribute('data-productqty'), 10);
    var qty = (qtyParsed > 0) ? String(qtyParsed) : '1';
    var price = el.getAttribute('data-productprice') || '';

    var tokenVal = (document.querySelector("#checkloginApi [name='__RequestVerificationToken']") || {}).value || '';
    var response = await fetch('/api/checklogin', { method: 'GET', headers: { 'RequestVerificationToken': tokenVal } });
    await _AntiForgeryToken('#checkloginApi');
    var data = await response.json();

    if (data.StatusCode == 200) {
      if (window.middysJoblist && typeof window.middysJoblist.open === 'function') {
        window.middysJoblist.open(productName, prontoCode, qty, price);
      }
    } else {
      localStorage.setItem('loginproductcode', prontoCode);
      localStorage.setItem('loginproductname', productName);
      localStorage.setItem('loginproductcodeQTY', qty);
      localStorage.setItem('loginproductcodePrice', price);
      location.reload();
    }
  }

  // ─── Featured Products ───────────────────────────────────────────────────────

  async function apiCallToGetFeaturedProductsGroupResonse() {
    var fpGroupName = document.querySelector("hawksearch-search-results").getAttribute("data-featured-product-group-name");
    if (!fpGroupName) return;
    fetch(window.location.origin + '/api/group?number=' + fpGroupName, {
      method: 'GET',
      headers: { "RequestVerificationToken": $("#checkloginApi [name='__RequestVerificationToken']").val() },
    }).then(function (result) { return result.json(); })
      .then(function (data) {
        antiForgeryRefresh("#checkloginApi");
        if (data && !data.hasOwnProperty('StatusCode')) {
          var productTitleElement = document.getElementById('product-list-title');
          var featureProductsDescription = document.getElementById('featured-products-description');
          if (productTitleElement) productTitleElement.textContent = data.name;
          if (featureProductsDescription && data.description) featureProductsDescription.innerHTML = data.description;
        }
      }, function (_error) { antiForgeryRefresh("#checkloginApi"); });
  }

  // ─── PLP / Search promo banners ──────────────────────────────────────────────
  // Restores productsListings.js: POST /api/GetPLPSearchCTA, then insert a full-width
  // .product-cta after Desktop/Tab/Mobile product counts. HawkSearch re-renders the
  // results list inside shadow DOM after hawksearch:after-search-executed.

  var PLP_BANNER_SLOT_COUNT = 8;
  var plpBanners = [];
  var plpBannerGeneration = 0;

  function plpBannerBreakpoint() {
    var width = $(window).width();
    if (width > 1024) return 'Desktop';
    if (width <= 1024 && width >= 768) return 'Tab';
    if (width < 768) return 'Mobile';
    return 'Desktop';
  }

  function plpFacetValues(facets, name) {
    var values = [];
    if (!facets) return values;
    Object.keys(facets).forEach(function (key) {
      if (key.toLowerCase() !== name) return;
      var raw = facets[key];
      var list = Array.isArray(raw) ? raw : [raw];
      list.forEach(function (value) {
        var text = value && typeof value === 'object' ? (value.value || value.Value || '') : value;
        text = text == null ? '' : String(text).trim();
        if (!text || text.charAt(0) === '-') return;
        if (values.indexOf(text) === -1) values.push(text);
      });
    });
    return values;
  }

  function plpAddUnique(list, value) {
    if (!value || list.indexOf(value) !== -1) return;
    list.push(value);
  }

  async function buildPlpBannerRequest() {
    var filters = [];
    var facets = (window.HawkSearch && HawkSearch.searchRequest && HawkSearch.searchRequest.facets) || {};
    var brands = plpFacetValues(facets, 'brand_name');
    var urlBrand = new URLSearchParams(window.location.search).get('brand_name');
    if (urlBrand) {
      urlBrand.split(',').forEach(function (part) { plpAddUnique(brands, part.trim()); });
    }
    if (brands.length) filters.push({ brand_name: brands });

    var categoryIds = plpFacetValues(facets, 'category');
    var resultsEl = document.querySelector('hawksearch-search-results');
    if (resultsEl && resultsEl.getAttribute('data-is-category-landing-page') === 'True') {
      ['data-hierarchy-id-1', 'data-hierarchy-id-2'].forEach(function (attr) {
        var id = resultsEl.getAttribute(attr);
        if (id) plpAddUnique(categoryIds, id);
      });
    }

    if (categoryIds.length) {
      var hierarchy = [];
      try {
        hierarchy = (await getHierarchy()) || [];
      } catch (e) {
        hierarchy = [];
      }
      var byId = {};
      var byPath = {};
      hierarchy.forEach(function (item) {
        if (!item) return;
        if (item.HierarchyId) byId[String(item.HierarchyId)] = item;
        if (item.Path) byPath[String(item.Path).toLowerCase()] = item;
      });
      var levels = { 1: [], 2: [], 3: [] };
      categoryIds.forEach(function (id) {
        var item = byId[String(id)];
        if (!item) return;
        var parts = String(item.Path || '').split('/').filter(Boolean);
        if (!parts.length) {
          plpAddUnique(levels[1], item.Value);
          return;
        }
        var prefix = '';
        parts.forEach(function (part, index) {
          prefix = prefix ? prefix + '/' + part : part;
          var node = byPath[prefix.toLowerCase()] || (index === parts.length - 1 ? item : null);
          var level = Math.min(index + 1, 3);
          plpAddUnique(levels[level], node && node.Value ? node.Value : '');
        });
      });
      if (levels[1].length) filters.push({ category_name_1: levels[1] });
      if (levels[2].length) filters.push({ category_name_2: levels[2] });
      if (levels[3].length) filters.push({ category_name_3: levels[3] });
    }

    return { filters: filters };
  }

  function plpAbsoluteUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    if (path.charAt(0) !== '/') path = '/' + path;
    return window.location.origin + path;
  }

  async function fetchPlpBanners() {
    try {
      var body = await buildPlpBannerRequest();
      var tokenEl = document.querySelector("#checkloginApi [name='__RequestVerificationToken']")
        || document.querySelector("#hawksearchApi [name='__RequestVerificationToken']");
      var response = await fetch(window.location.origin + '/api/GetPLPSearchCTA', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          RequestVerificationToken: tokenEl ? tokenEl.value : ''
        },
        body: JSON.stringify(body)
      });
      if (!response.ok) return [];
      var text = await response.text();
      if (!text) return [];
      var data = JSON.parse(text);
      if (typeof data === 'string') data = JSON.parse(data);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.error('Error while getting PLP/Search CTA', e);
      return [];
    }
  }

  function plpAssignPosition(banners, pageSize, index, positionType) {
    return banners.length >= (index + 1)
      ? (Object.prototype.hasOwnProperty.call(banners[index], positionType) ? banners[index][positionType] : pageSize)
      : pageSize;
  }

  function plpBannerSlices(items, banners, positionType) {
    var pageSize = items.length;
    var positions = [];
    for (var i = 0; i < PLP_BANNER_SLOT_COUNT; i++) {
      positions.push(plpAssignPosition(banners, pageSize, i, positionType));
    }
    var slices = [];
    for (var s = 0; s < positions.length; s++) {
      var start = s === 0 ? 0 : positions[s - 1];
      slices.push(items.slice(start, positions[s]));
    }
    slices.push(items.slice(positions[positions.length - 1]));
    return slices;
  }

  function ensurePlpBannerStyles(shadow) {
    if (shadow.querySelector('style[data-plp-cta]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-plp-cta', '1');
    style.textContent = [
      '.product-cta {',
      '  background: #F3F4F6;',
      '  border: 1px solid #D1D5DB;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  margin: 0 auto 20px;',
      '}',
      '.product-cta img { display: block; max-width: 100%; height: auto; }',
      '.product-cta a { display: block; line-height: 0; }'
    ].join('\n');
    shadow.insertBefore(style, shadow.firstChild);
  }

  function buildPlpBannerElement(banner, imageKey) {
    var wrap = document.createElement('div');
    wrap.className = 'product-cta plp-search-cta';
    wrap.style.display = 'block';
    var link = document.createElement('a');
    var hasUrl = banner.RedirectionURL !== '' && banner.RedirectionURL != null;
    link.href = hasUrl ? plpAbsoluteUrl(banner.RedirectionURL) : '#';
    link.target = banner.IsOpenInNewTab === true ? '_blank' : '_self';
    if (!hasUrl) link.addEventListener('click', function (event) { event.preventDefault(); });
    var img = document.createElement('img');
    img.alt = 'cta';
    img.src = plpAbsoluteUrl(banner[imageKey] || '');
    link.appendChild(img);
    wrap.appendChild(link);
    return wrap;
  }

  function getPlpResultsShadows() {
    return queryAllHawksearchHosts('hawksearch-search-results-list')
      .map(function (host) { return host.shadowRoot; })
      .filter(Boolean);
  }

  function collectPlpProductItems(shadow) {
    return Array.prototype.slice.call(shadow.querySelectorAll('hawksearch-search-results-item'));
  }

  function placePlpBanners(banners) {
    var shadows = getPlpResultsShadows();
    if (!shadows.length) return false;
    var breakpoint = plpBannerBreakpoint();
    var positionKey = breakpoint + 'Position';
    var imageKey = breakpoint === 'Desktop' ? 'DesktopImage' : (breakpoint === 'Tab' ? 'TabImage' : 'MobileImage');
    var placed = false;

    shadows.forEach(function (shadow) {
      var items = collectPlpProductItems(shadow);
      if (!items.length) return;
      ensurePlpBannerStyles(shadow);
      shadow.querySelectorAll('.plp-search-cta').forEach(function (el) { el.remove(); });

      var existingGroups = shadow.querySelector('.plp-banner-groups');
      var anchor = existingGroups || shadow.querySelector('.search-results-list');
      if (!anchor || !anchor.parentNode) return;

      if (!banners || !banners.length) {
        if (existingGroups) {
          var flat = document.createElement('div');
          flat.className = 'flex search-results-list';
          items.forEach(function (item) { flat.appendChild(item); });
          existingGroups.parentNode.insertBefore(flat, existingGroups);
          existingGroups.remove();
        }
        placed = true;
        return;
      }

      var groups = document.createElement('div');
      groups.className = 'plp-banner-groups';
      plpBannerSlices(items, banners, positionKey).forEach(function (slice, index) {
        if (slice.length) {
          var group = document.createElement('div');
          group.className = 'flex search-results-list';
          slice.forEach(function (item) { group.appendChild(item); });
          groups.appendChild(group);
        }
        if (banners[index]) groups.appendChild(buildPlpBannerElement(banners[index], imageKey));
      });

      anchor.parentNode.insertBefore(groups, anchor);
      if (existingGroups) existingGroups.remove();
      else anchor.remove();
      placed = true;
    });

    return placed;
  }

  function schedulePlacePlpBanners() {
    var generation = plpBannerGeneration;
    var started = Date.now();
    var previousMarker = null;
    var placedOn = null;
    function tick() {
      if (generation !== plpBannerGeneration) return;
      var marker = null;
      getPlpResultsShadows().some(function (shadow) {
        var items = collectPlpProductItems(shadow);
        if (items.length) {
          marker = items[0];
          return true;
        }
        return false;
      });
      // after-search-executed fires before the shadow list is replaced. Wait until the
      // same result node is still there on the next tick, then insert. A later render
      // swaps the node and this runs again.
      if (marker && marker === previousMarker && marker !== placedOn) {
        placePlpBanners(plpBanners);
        placedOn = marker;
      }
      previousMarker = marker;
      if (Date.now() - started < 1500) setTimeout(tick, 100);
    }
    tick();
  }

  function refreshPlpBanners() {
    var generation = ++plpBannerGeneration;
    fetchPlpBanners().then(function (banners) {
      if (generation !== plpBannerGeneration) return;
      plpBanners = banners;
      schedulePlacePlpBanners();
    });
  }

  var plpBannerResizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(plpBannerResizeTimer);
    plpBannerResizeTimer = setTimeout(function () {
      if (plpBanners && plpBanners.length) placePlpBanners(plpBanners);
    }, 150);
  });

  // ─── HawkSearch Event Listeners ──────────────────────────────────────────────

  /** Shared reinit called on hawksearch:initialized, hawksearch:loaded, and hawksearch:after-search-executed. */
  function reinitSelect2AndMobile() {
    hawksearchSort2RetryCount = 0;
    hawksearchPageSize2RetryCount = 0;
    scheduleInitHawksearchSortingSelect2();
    scheduleInitHawksearchPageSizeSelect2();
    attachHawksearchSearchResultsMobileObservers();
    scheduleMobileAdjustments();
  }

  addEventListener("hawksearch:initialized", function () {
    // Override `facet-checkbox-list` in a way that "wins" even if HawkSearch registers its default later.
    // The built-in checkbox facet registers this partial during its own lifecycle, so we intercept.
    var customFacetCheckboxListPartial = `
      <ul class="parent-category" style="display: block;">
        {{#each this}}
          {{#if visible}}
            <li>
            {{#if selected}}
                <input id="{{@root.id}}-{{value}}" type="checkbox" checked hawksearch-facet-value value="{{value}}"/>
            {{else}}
                <input id="{{@root.id}}-{{value}}" type="checkbox" hawksearch-facet-value value="{{value}}"/>
            {{/if}}
              <label class="cat-label" for="{{@root.id}}-{{value}}"><span class="span">{{title}}</span><span class="item-count">({{count}})</span></label>
              {{#if selected}}
              {{> child-facet-checkbox-list children}}
              {{/if}}
            </li>
          {{/if}}
        {{/each}}
      </ul>
    `.trim();

    var childFacetCheckboxListPartial = `
      <ul class="child-category" style="display: block;">
        {{#if (hasCategory2)}}
          {{#if (matchesCategory2 this)}}
            {{#each this}}
              {{#if selected}}
                <li>
                  <input id="{{@root.id}}-{{value}}" type="checkbox" checked hawksearch-facet-value value="{{value}}"/>
                  <label class="cat-label" for="{{@root.id}}-{{value}}"><span class="span">{{title}}</span><span class="item-count">({{count}})</span></label>
                  {{> child-facet-checkbox-list children}}
                </li>
              {{/if}}
            {{/each}}
          {{else}}
            {{#each this}}
              <li>
                {{#if selected}}
                  <input id="{{@root.id}}-{{value}}" type="checkbox" checked hawksearch-facet-value value="{{value}}"/>
                {{else}}
                  <input id="{{@root.id}}-{{value}}" type="checkbox" hawksearch-facet-value value="{{value}}"/>
                {{/if}}
                <label class="cat-label" for="{{@root.id}}-{{value}}"><span class="span">{{title}}</span><span class="item-count">({{count}})</span></label>
                {{#if selected}}
                  {{> child-facet-checkbox-list children}}
                {{/if}}
              </li>
            {{/each}}
          {{/if}}
        {{else}}
          {{#each this}}
            <li>
              {{#if selected}}
                <input id="{{@root.id}}-{{value}}" type="checkbox" checked hawksearch-facet-value value="{{value}}"/>
              {{else}}
                <input id="{{@root.id}}-{{value}}" type="checkbox" hawksearch-facet-value value="{{value}}"/>
              {{/if}}
              <label class="cat-label" for="{{@root.id}}-{{value}}"><span class="span">{{title}}</span><span class="item-count">({{count}})</span></label>
              {{#if selected}}
                {{> child-facet-checkbox-list children}}
              {{/if}}
            </li>
          {{/each}}
        {{/if}}
      </ul>
    `.trim();

    if (HawkSearch && HawkSearch.handlebars && HawkSearch.handlebars.registerPartial) {
      var hb = HawkSearch.handlebars;
      var origRegisterPartial = hb.registerPartial.bind(hb);
      hb.registerPartial = function (name, template) {
        if (name === "facet-checkbox-list") return origRegisterPartial(name, customFacetCheckboxListPartial);
        return origRegisterPartial(name, template);
      };
      hb.registerPartial("facet-checkbox-list", customFacetCheckboxListPartial);
      hb.registerPartial("child-facet-checkbox-list", childFacetCheckboxListPartial);
    }

    var getSearchResultsEl = function () { return document.querySelector("hawksearch-search-results"); };

    HawkSearch.handlebars.registerHelper("matchesCategory2", function (value) {
      var el = getSearchResultsEl();
      if (!el) return false;
      var cat2 = el.getAttribute("data-hierarchy-id-2");
      if (!cat2 || value == null) return false;
      var cat2Normalized = String(cat2).trim().toLowerCase();
      var values = Array.isArray(value) ? value : [value];
      return values.some(function (v) {
        return v != null && String(v.value).trim().toLowerCase() === cat2Normalized;
      });
    });

    HawkSearch.handlebars.registerHelper("hasCategory2", function () {
      var el = getSearchResultsEl();
      if (!el) return false;
      var cat2 = el.getAttribute("data-hierarchy-id-2");
      return cat2 != null && cat2 !== "";
    });

    HawkSearch.handlebars.registerHelper("isCategoryLandingPage", function () {
      var el = getSearchResultsEl();
      return el && el.getAttribute("data-is-category-landing-page") === "True";
    });

    HawkSearch.handlebars.registerHelper("showfirstpagelink", function (currentPage) {
      return currentPage > 3;
    });

    HawkSearch.handlebars.registerHelper("showlastpagelink", function (currentPage, totalPages) {
      return currentPage < totalPages - 2;
    });

    HawkSearch.handlebars.registerHelper("isRecentlyPurchasedItem", function (productId) {
      if (!window.__hawkPurchaseHistoryPrefetch || !productId) return false;
      var idVal = Array.isArray(productId) ? productId[0] : productId;
      return window.__hawkPurchaseHistoryPrefetch.some(function (p) { return p && p.productNumber === idVal; });
    });

    HawkSearch.handlebars.registerHelper("isMiddysEssentialsItem", function (featuredProductGroupNames) {
      featuredProductGroupNames = Array.isArray(featuredProductGroupNames) ? featuredProductGroupNames : [featuredProductGroupNames];
      var el = getSearchResultsEl();
      if (!el) return false;
      var featuredProductGroupId = el.getAttribute("data-featured-product-group-name");
      if (featuredProductGroupId === "middys-essentials") return false;
      return featuredProductGroupNames.some(function (name) { return name.toLowerCase() === "middy's essentials"; });
    });

    HawkSearch.handlebars.registerHelper("isCableProduct", function (productGroup) {
      if (!window.hawksearchProductListing) return false;
      var val = Array.isArray(productGroup) ? productGroup[0] : productGroup;
      if (!val) return false;
      var el = getSearchResultsEl();
      if (!el) return false;
      var csv = el.getAttribute("data-cableproductgroups") || "";
      var groups = csv.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
      return groups.indexOf(val) !== -1;
    });

    // Prefer a, fallback to b (for title/url/image when API shape differs)
    HawkSearch.handlebars.registerHelper("or", function (a, b) {
      if (a !== undefined && a !== null && a !== "") return a;
      return typeof b === "function" ? b() : b;
    });

    HawkSearch.handlebars.registerHelper("isLoggedIn", function () {
      return window.hawksearchProductListing ? window.hawksearchProductListing.isLoggedIn() : false;
    });

    HawkSearch.handlebars.registerHelper("getJobListPermission", function () {
      return window.hawksearchProductListing ? window.hawksearchProductListing.getJobListPermission() : false;
    });

    reinitSelect2AndMobile();
    scheduleApplyExcludeOutOfStockState();
  }, false);

  addEventListener("hawksearch:loaded", function () {
    reinitSelect2AndMobile();
  }, false);

  /**
   * After any search (including clearFilters → search()), HawkSearch re-renders and may replace
   * the native sort dropdown in shadow DOM — Select2 must be wired again.
   */
  addEventListener("hawksearch:after-search-executed", function (e) {
    hawkLastSearchResponse = (e && e.detail) || null;
    captureOpenFacetTitles();
    reinitSelect2AndMobile();
    scheduleApplyExcludeOutOfStockState();
    scheduleFocusFirstSearchResult();
    scheduleHawkNoResultsCheck();
    scheduleRestoreOpenFacets();
    refreshPlpBanners();
  }, false);

  addEventListener("hawksearch:search-failed", function () {
    showSearchErrorMessage();
  }, false);

  // ─── DOM Ready ───────────────────────────────────────────────────────────────

  var hawksearchSort2BodyMoTimer = null;

  $(function () {
    wireFacetSelectionPageReset();
    attachHawksearchSortingShadowObservers();
    attachHawksearchPageSizeShadowObservers();
    attachHawksearchSearchResultsMobileObservers();
    new MutationObserver(function () {
      if (hawksearchSort2BodyMoTimer) clearTimeout(hawksearchSort2BodyMoTimer);
      hawksearchSort2BodyMoTimer = setTimeout(function () {
        hawksearchSort2BodyMoTimer = null;
        attachHawksearchSortingShadowObservers();
        attachHawksearchPageSizeShadowObservers();
        attachHawksearchSearchResultsMobileObservers();
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });
    scheduleInitHawksearchSortingSelect2();
    scheduleInitHawksearchPageSizeSelect2();
    scheduleMobileAdjustments();
  });

  // ─── Reload / Re-search ──────────────────────────────────────────────────────

  function reloadMiddysProductListing() {
    function run() {
      if (
        typeof window.HawkSearch === "undefined" ||
        !HawkSearch.services ||
        !HawkSearch.services.search ||
        typeof HawkSearch.services.search.getRequestFromUrl !== "function" ||
        typeof HawkSearch.services.search.search !== "function"
      ) {
        return;
      }
      resetSearchPageInUrl();
      var req = HawkSearch.services.search.getRequestFromUrl();
      HawkSearch.services.search.search(req);
    }

    if (typeof window.HawkSearch === "undefined") {
      addEventListener("hawksearch:loaded", function () { run(); }, { once: true });
      return;
    }
    run();
  }

  window.reloadMiddysProductListing = reloadMiddysProductListing;

  // ─── Public API ───────────────────────────────────────────────────────────────

  window.hawksearchProductListing = {
    onProdCodeMouseOver: onProdCodeMouseOver,
    onProdCodeMouseOut: onProdCodeMouseOut,
    getLogin: getLogin,
    getJobListPermission: getJobListPermission,
    getVersion: getVersion,
    isLoggedIn: isLoggedIn,
    showLoginPopup: showLoginPopup,
    getPurchaseHistory: getPurchaseHistory,
    getHierarchy: getHierarchy,
    clearFilters: clearFilters,
    toggleFilterFacet: toggleFilterFacet,
    initHawksearchSortingSelect2: initHawksearchSortingSelect2,
    queryAllHawksearchSortingHosts: queryAllHawksearchSortingHosts,
    initHawksearchPageSizeSelect2: initHawksearchPageSizeSelect2,
    queryAllHawksearchPageSizeHosts: queryAllHawksearchPageSizeHosts,
    addToCart: addToCart,
    addToJobList: addToJoblist,
    apiCallToGetFeaturedProductsGroupResonse: apiCallToGetFeaturedProductsGroupResonse,
    reloadMiddysProductListing: reloadMiddysProductListing,
    showWarningPopup: showWarningPopup,
    handleCancelPopupClick: handleCancelPopupClick,
    handleWarningPopupClick: handleWarningPopupClick,
  };
})();
